import "../utils/JsErrorLogging";

// TODO RCH : is placeholder usefull ? if yes, is it used on all pages ?
import "../lib/placeholders.min";
import "../legacy/app/main";
import "../legacy/foundation-init";
import "../legacy/background-loading";
import "../lib/pym.v1.min";


// WEBPACK FOOTER //
// ./js/page/UserPage.js